<div class="modal-container modal-md justify-between md:justify-normal">
    <div class="modal-close-container">
        <bizz-icon class="ml-auto block h-5 w-5 text-button md:ml-0"
                   (click)="dialogRef.close()"
                   iconName="xmark" [hover]="true">
        </bizz-icon>
    </div>
    <div class="modal-body"
         [class]="{
        '!min-h-[20svh]': modalType != CompareModalType.Delete,
        '!min-h-[40svh]': modalType == CompareModalType.Delete}">
        <div class="modal-header">
            <h1>
                @switch (modalType) {
                    @case (CompareModalType.Read) {
                        {{ 'Read' | translate }}
                    }
                    @case (CompareModalType.Delete) {
                        {{ 'Delete' | translate }}
                    }
                    @case (CompareModalType.Edit) {
                        {{ 'Edit' | translate }}
                    }
                    @case (CompareModalType.ViewOnline) {
                        {{ 'View' | translate }}
                    }
                    @case (CompareModalType.EditOnline) {
                        {{ 'Edit' | translate }}
                    }
                }
                {{ model.PublicVersion['Title']?.Value }}</h1>
            <h2 class="sm:text-center text-sm text-light">
                {{ 'Info_ThereAreMultipleVersionsOfThisDocument' | translate }}<br/>
                @switch (modalType) {
                    @case (CompareModalType.Read) {
                        {{ 'WhichVersionWouldYouLikeToRead' | translate }}
                    }
                    @case (CompareModalType.Delete) {
                        {{ 'WhichVersionWouldYouLikeToDelete' | translate }}
                    }
                    @case (CompareModalType.Edit) {
                        {{ 'WhichVersionWouldYouLikeToEdit' | translate }}
                    }
                    @case (CompareModalType.ViewOnline) {
                        {{ 'WhichVersionWouldYouLikeToViewOnline' | translate }}
                    }
                    @case (CompareModalType.EditOnline) {
                        {{ 'WhichVersionWouldYouLikeToEditOnline' | translate }}
                    }
                }
            </h2>
        </div>
        <hr class="my-5"/>
        <div class="flex flex-wrap justify-center w-full px-1 gap-x-4 gap-y-8 mt-8 mb-4">
            <bizz-compare-button
                    (onClick)="onClick($event, VersionType.Public)"
                    [versionType]="VersionType.Public"
                    [versionDate]="model.PublicVersion['VersionDate']?.Value"
                    [archiveDate]="model.PublicVersion['ArchiveDate']"
                    [version]="model.PublicVersion['Version']?.Value"
                    [isSelected]="selectedVersion === VersionType.Public"
            ></bizz-compare-button>
            @if (hasDraft) {
                <bizz-compare-button
                        (onClick)="onClick($event, VersionType.Draft)"
                        [versionType]="VersionType.Draft"
                        [versionDate]="model.DraftVersion['VersionDate']?.Value"
                        [archiveDate]="model.DraftVersion['ArchiveDate']"
                        [version]="model.DraftVersion['Version']?.Value"
                        [isSelected]="selectedVersion === VersionType.Draft"
                ></bizz-compare-button>
            }
            @if (hasPrepublication) {
                <bizz-compare-button
                        (onClick)="onClick($event, VersionType.Prepublication)"
                        [versionType]="VersionType.Prepublication"
                        [versionDate]="model.PrepublicationVersion['VersionDate']?.Value"
                        [archiveDate]="model.PrepublicationVersion['ArchiveDate']"
                        [version]="model.PrepublicationVersion['Version']?.Value"
                        [isSelected]="selectedVersion === VersionType.Prepublication">
                </bizz-compare-button>
            }
        </div>
        @if (modalType === CompareModalType.Delete) {
            <div class="md:max-w-3xl">
                @if (selectedVersion === VersionType.Public) {
                    <p class="text-sans w-full whitespace-normal text-xs font-normal">
                        {{ 'Info_DeletionOfThePublicVersion' | translate }}
                    </p>
                }
                @if (selectedVersion === VersionType.Public && model.folders && model.folders.length > 0) {
                    <div>
                        <br/>
                        <div class="mt-4">
                            @for (tree of model.folders; track $index) {
                                <div>
                                    <h4><b>{{ tree.Tree }}</b></h4>
                                    <ul class="ml-5 list-disc">
                                        @for (folder of tree.Folders; track $index) {
                                            <li>
                                                {{ folder.FolderCaption }}
                                                @if (folder.TargetType == FolderInstanceTargetType.Link) {
                                                    <bizz-icon class="ml-auto block h-5 w-5 text-button md:ml-0"
                                                               iconName="rotate-right">
                                                    </bizz-icon>
                                                }
                                            </li>
                                        }
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
            <hr class="my-5"/>
            <div class="h-full">
                <label class="mb-2 inline-block text-sm text-default">{{ 'ReasonDelete' | translate }}
                    <span class="ml-0.5 text-red-400">*</span>
                </label>
                <kendo-textarea
                        [rows]="8"
                        size="large"
                        resizable="vertical"
                        [(value)]="deleteReason"
                        fillMode="solid"
                        rounded="large"
                ></kendo-textarea>
            </div>
        }
    </div>
    @if (modalType === CompareModalType.Delete) {
        <div class="modal-buttons">
            <button class="default" (click)="dialogRef.close()"><span>{{ 'Cancel' | translate }}</span></button>
            <button class="delete" (click)="delete()" [disabled]="selectedVersion == undefined || deleteReason == ''">
                {{
                    selectedVersion === VersionType.Public ?
                            ('DeletePublicVersion' | translate) : ('DeleteDraftVersion' | translate)
                }}
            </button>
        </div>
    }
</div>
